/** Where a notification row goes when opened. Unknown slugs stay in the list. */
const SLUG_ROUTES: Record<string, string> = {
  shift_assigned_in_app: "/scheduling",
  shift_removed_in_app: "/scheduling",
  shift_time_changed_in_app: "/scheduling",
  shift_dropped_in_app: "/scheduling",
  program_drafted_in_app: "/programs",
  hours_rejected_in_app: "/time-tracker",
  hours_approved_in_app: "/time-tracker",
  event_manager_rsvp_update_in_app: "/events",
  cross_org_referral_in_app: "/cases",
  task_assigned_in_app: "/tasks",
  task_due_tomorrow_in_app: "/tasks",
  task_overdue_in_app: "/tasks",
  case_assigned_in_app: "/cases",
  case_note_added_in_app: "/cases",
  service_log_decided_in_app: "/cases",
  member_application_submitted_in_app: "/community",
  member_application_decided_in_app: "/community",
  expense_submitted_in_app: "/submission-center",
  expense_decided_in_app: "/submission-center",
  bill_submitted_in_app: "/submission-center",
  bill_decided_in_app: "/submission-center",
  timesheet_submitted_in_app: "/accounting",
  timesheet_decided_in_app: "/time-tracker",
  inventory_decided_in_app: "/inventory",
  inventory_low_stock_in_app: "/inventory?tab=items&stock_status=low_stock",
  grant_budget_submitted_in_app: "/grants",
  announcement_published_in_app: "/",
};

export function routeForNotificationSlug(slug: string | undefined): string | null {
  if (!slug) return null;
  return SLUG_ROUTES[slug] ?? null;
}
